module.exports = __webpack_public_path__ + "static/media/travelBlue.f79dfcb2.svg";